jQuery( document ).ready(function() {
    setTimeout(imageOneFade(), 3000);

    function imageOneFade() {
        jQuery('#biker').fadeIn(1000, function(){ 
            setTimeout(function(){ 
                jQuery('#biker').fadeOut(1000); imageTwoFade();
            }
            ,4000);
    });
    }
    function imageTwoFade() {
        jQuery('#fisher').fadeIn(1000, function(){ setTimeout( function(){
            jQuery('#fisher').fadeOut(1000);
            imageOneFade();
        },4000); 
        });
    }
      
});